import React from "react";

export function useDebounce() {
  const timeoutRef = React.useRef<NodeJS.Timeout>();

  return React.useCallback((callback: () => void, delay: number) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(callback, delay);
  }, []);
}
